@for (message of messages$ | async; track message) {
  <div class="nag">
    <div class="nag-body">
      {{ message.text }}
      @if (message.action) {
        <app-ui-button [variant]="'primary'" [size]="'micro'" [label]="message.actionBtnText"
          [capability]="message.capability"
          [isDisabled]="message.loading" [isLoadingState]="message.loading"
          (clicked)="action(message)">
        </app-ui-button>
      } @else {
        @if (message.route) {
          <app-ui-button-text [capability]="message.capability" [label]="message.routeText"
            (clicked)="navigate(message)">
          </app-ui-button-text>
        }
      }
    </div>
    @if (message.dismissible) {
      <app-ui-button-icon [variant]="'floating'" [size]="'micro'" [icon]="IconsEnum.close_large" [isDisabled]="message.loading"
        (clicked)="remove(message)">
      </app-ui-button-icon>
    }
  </div>
}
